export const WAYMAN_PROVIDER = "wayman";
export const canvasHeight = 2000;
export const canvasWidth = 4000;
export const REM = window.innerWidth <= 700 ? window.innerWidth / 45 : parseInt(window.getComputedStyle(document.body).fontSize.slice(0, 2));
export const GRID = 1.875 * REM;
export const LINE_WIDTH = 0.1875 * REM;
export const TEXT_EDITOR_OPTIONS = ["fontSize", "colorPicker", "inline"];
export const TEXT_EDITOR_INLINE_OPTIONS = ["bold", "italic", "underline"];
